// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__14Kui","formShake":"styles_formShake__3r0Hh","shake":"styles_shake__-KCXN","error":"styles_error__3j-of"};